/**
 * Ranking por produtos presentes em `produtos_comprados` dos pedidos convertidos.
 * @param {Array} pedidosConvertidos - lista de pedidos da API (pedidos_convertidos)
 * @param {number} limite - máximo de itens (default 5)
 */
export default function rankingProdutosPorComprasConvertidas(pedidosConvertidos, limite = 5) {
  if (!Array.isArray(pedidosConvertidos) || !pedidosConvertidos.length) return []

  const byId = {}

  const enrichFromRecomendacoes = (pedido, productId) => {
    const recs = pedido.produtos_recomendados || []
    const id = String(productId)
    const rec = recs.find(r => String(r.product_id) === id)
    if (!rec) return {}
    return {
      product_name: rec.product_name,
      link_imagem: rec.link_imagem,
      link_produto: rec.link_produto,
      categoria: rec.metadata && rec.metadata.categoria ? rec.metadata.categoria : null,
    }
  }

  for (let i = 0; i < pedidosConvertidos.length; i += 1) {
    const pedido = pedidosConvertidos[i]
    const comprados = pedido.produtos_comprados || []
    for (let j = 0; j < comprados.length; j += 1) {
      const pc = comprados[j]
      if (pc.purchased !== false) {
        const pid = pc.product_id != null ? String(pc.product_id) : null
        if (pid) {
          if (!byId[pid]) {
            const meta = enrichFromRecomendacoes(pedido, pid)
            byId[pid] = {
              product_id: pid,
              product_name: meta.product_name || `Produto ${pid}`,
              link_imagem: meta.link_imagem || '',
              link_produto: meta.link_produto || '',
              categoria: meta.categoria || 'Produto',
              conversoes_pedidos: 0,
              receita_gerada: 0,
            }
          }
          byId[pid].conversoes_pedidos += 1
          const v = typeof pc.valor === 'number' ? pc.valor : parseFloat(pc.valor) || 0
          byId[pid].receita_gerada += v
        }
      }
    }
  }

  const ids = Object.keys(byId)
  for (let k = 0; k < ids.length; k += 1) {
    const pid = ids[k]
    const row = byId[pid]
    const precisaEnriquecer = !row.product_name || String(row.product_name).startsWith('Produto ')
    if (precisaEnriquecer) {
      for (let p = 0; p < pedidosConvertidos.length; p += 1) {
        const recs = pedidosConvertidos[p].produtos_recomendados || []
        const rec = recs.find(r => String(r.product_id) === pid)
        if (rec) {
          row.product_name = rec.product_name || row.product_name
          row.link_imagem = rec.link_imagem || row.link_imagem
          row.link_produto = rec.link_produto || row.link_produto
          if (rec.metadata && rec.metadata.categoria) row.categoria = rec.metadata.categoria
          break
        }
      }
    }
  }

  const list = Object.values(byId)
  list.sort((a, b) => {
    if (b.conversoes_pedidos !== a.conversoes_pedidos) {
      return b.conversoes_pedidos - a.conversoes_pedidos
    }
    return b.receita_gerada - a.receita_gerada
  })

  return list.slice(0, limite).map(row => ({
    ...row,
    conversao_raw: row.conversoes_pedidos,
    conversao_pct: `${row.conversoes_pedidos} ${row.conversoes_pedidos === 1 ? 'pedido' : 'pedidos'}`,
    vezes_recomendado: row.conversoes_pedidos,
  }))
}
